<loader *ngIf='cartService.loading.value || _previewing'></loader>

<div class="empty_space"></div>

<div class="container">
	<ng-container *ngIf='!cartService.loading.value'>
		<div class="row">
			<h2 class="title-page">{{'Carrello' | translate}}</h2>
		</div>
	
		<div class="row" *ngIf='cartData.num_items; else noitems;'>
			<div class="col-xl-8 col-lg-8 col-md-12">
				<ng-container *ngFor='let key of cartData.cart_items | customKeys'>
					<!-- switch component target base -->
					<ng-container [ngSwitch]='cartData.cart_items[key].target'>
						<!-- trip_package -->
						<trip-package-cart-page
							*ngSwitchCase='"trip_packages"'
							[cartItem]='cartData.cart_items[key]'
						></trip-package-cart-page>
						<!-- product -->
						<product-cart-page
							*ngSwitchCase='"product"'
							[cartItem]='cartData.cart_items[key]'
							(_previewing)='_previewing = $event'
						></product-cart-page>
						<!-- default -->
						<div *ngSwitchDefault>Nessun componente configurato per il target passato</div>
					</ng-container>

					<span class="coupon_message" *ngIf='messageCoupons' #couponMsg>
						{{messageCoupons[key].message}}<!-- &nbsp;<i class="fa fa-times"></i> -->
					</span>
				</ng-container>

				<span class="coupon_message generic_message" *ngIf='cartService.showGenericErrorCoupon' #genericError>
					Si è verificato un errore.&nbsp;<i class="fa fa-times" (click)='clearGenericError()'></i>
				</span>

				<backtolist></backtolist>

				<!-- coupons -->
				<div class="row coupon-row" *ngIf='cartData.num_items'>
					<div class="col-xl-8 col-lg-8 col-md-12" style="padding: 0;">
						<form [formGroup]='formGroup' (ngSubmit)='onSubmit()'>
							<label><b>{{'Inserisci un codice regalo o promozionale' | translate}}</b></label>
							<div class="inputs">
								<input #coupon_code type="text" formControlName="coupon_code" class="coupon_code form-control" />
								<button [disabled]='!coupon_code.value.length' type="submit" class="btn btn-primary submit-btn btn-small btn-redeem">
									{{'APPLICA CODICE' | translate}}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		
			<div class="col-xl-4 col-lg-4 col-md-12">
				<div id="checkout-button-wrapper" class="checkout-button-wrapper">
					<div id="checkout-button" class="module checkout-button">
						<div class="label subtotal">
							<span>{{'Subtotale' | translate}}</span>
							<span class="price-tag">
								<p class="total-price">{{cartData.subtotal_cart | currency:'EUR'}}</p>
							</span>
						</div>
						<ng-container *ngIf='cartData.total_discount < 0'>
							<div class="label discount">
								<span>{{'Sconto' | translate}}</span>
								<span class="price-tag">
									<p class="total-price">{{cartData.total_discount | currency:'EUR'}}</p>
								</span>
							</div>
						</ng-container>
						<div class="label">
							<span>{{'Totale' | translate}}</span>
							<span class="price-tag">
								<p class="total-price">{{cartData.total_cart | currency:'EUR'}}</p>
							</span>
						</div>
						<a [routerLink]='["/d", appService.domainId, "checkout"]' class="btn btn-cta btn-checkout">
							{{'Procedi all\'acquisto' | translate}}
						</a>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<ng-template #noitems>
	<div class="no-items">{{'Nessun elemento presente nel carrello' | translate}}</div>
	<backtolist></backtolist>
</ng-template>